// Used to spread tabProps

import { useCallback } from "react";

import { Tab, Tabs } from "@mui/material";
import { SxProps, Theme } from "@mui/material/styles";
import Tooltip from "@mui/material/Tooltip";

import { ITab } from "@components/CompanyDetailsDrawer/CompanyDisplay";
import NewChip from "@components/NewChip";

import tabStyles from "./tabStyles";

interface ITabGroupProperties {
  index: number;
  setIndex: (index: number) => void;
  sx?: SxProps<Theme>;
  tabs: ITab[];
}

const tabProperties = (index: number) => ({
  "aria-controls": `simple-tabpanel-${index}`,
  id: `simple-tab-${index}`,
});

export default function TabGroup({ index, setIndex, sx, tabs }: ITabGroupProperties) {
  const handleChange = useCallback(
    (_: unknown, newValue: number) => {
      setIndex(newValue);
    },
    [setIndex],
  );

  const renderTabLabel = (tab: ITab, indx: number) => {
    const isActive = indx === index;

    return (
      <div style={{ alignItems: "center", display: "flex" }}>
        {tab.label}
        {tab.new && <NewChip isActive={isActive} />}
      </div>
    );
  };

  return (
    <Tabs
      aria-label="simple tabNavButtons example"
      onChange={handleChange}
      sx={{
        "& .MuiTabs-indicator": {
          display: "none",
        },
        borderRadius: "8px",
        mb: 4,
        overflow: "visible",
        px: 4,
        width: "fit-content",
        ...sx,
      }}
      value={index}
    >
      {tabs.map((tab, index) => (
        <Tooltip key={tab.label} placement="bottom" title={tab.tooltip}>
          <Tab
            disabled={tab.disabled}
            label={renderTabLabel(tab, index)}
            {...tabProperties(index)}
            sx={{
              ...tabStyles,
            }}
          />
        </Tooltip>
      ))}
    </Tabs>
  );
}
